import * as Types from "../actionTypes/networkStateTypes";

export const setBrowserOnline = (payload) => ({
  type: Types.SET_BROWSER_ONLINE,
  payload,
});

export const setSocketStatus = (payload) => ({
  type: Types.SET_SOCKET_STATUS,
  payload,
});

export const setSocketReconnectAttempt = (payload) => ({
  type: Types.SET_SOCKET_RECONNECT_ATTEMPT,
  payload,
});

export const resetNetworkState = () => ({
  type: Types.RESET_NETWORK_STATE,
});
